// extracted by mini-css-extract-plugin
module.exports = {"product_information":"ProductDetail_product_information__3p_Cy","video":"ProductDetail_video__1fZx7"};